export const fr = {
  bookDemoNonprofitPage: {
    meta: { title: 'Réserver une démo — Organismes' },
    eyebrow: 'Réserver une démo',
    heading_main: 'Découvrez comment Purposely amène des bénévoles',
    heading_em: 'à votre cause',
    lead: "Nous travaillons avec des entreprises qui gèrent des programmes de bénévolat pour leurs employés et nous aimerions vous mettre en contact avec elles. Il s'agit d'une courte conversation pour mieux connaître votre organisation et trouver comment nous pouvons soutenir votre travail.",
    expect: [
      {
        title: '30 minutes, échange rapide',
        sub: "Nous vous poserons des questions sur vos programmes, votre capacité et le type de bénévoles d'entreprise qui conviendrait à votre travail.",
      },
      {
        title: 'Une conversation, pas un pitch',
        sub: "Nous souhaitons comprendre votre mission pour pouvoir vous connecter avec les bonnes entreprises et bénévoles.",
      },
      {
        title: 'Rejoignez le réseau',
        sub: "Si c'est une bonne correspondance, nous ajouterons votre organisation à notre plateforme.",
      },
    ],
    trust: {
      heading: 'Organismes déjà sur la plateforme',
      logos: ['Whole Way House', 'Global Medic', 'SickKids Foundation', 'Kits for a Cause'],
    },
    cal: {
      heading: 'Choisissez un créneau',
      sub: "Tous les horaires sont dans votre fuseau horaire local. Nous vous enverrons une invitation de calendrier immédiatement.",
    },
    fallback: {
      strong: "Vous préférez l'email ?",
      text: "Nous vous trouverons un créneau dans un jour ouvrable.",
      email: 'demo@purposely.co',
    },
  },
}
